import React from 'react';

const ServiceWorkerContext = React.createContext();

export default ServiceWorkerContext;
